import {getValidToken} from "@/script/storageToken";
import { $axios, $axiosUrl, apiList } from '@/api'
import { config } from '@/script/cache/configuration'

export default {
    state: () => ({
        findedFiles: []
    }),
    mutations: {
        setFindedFiles(state, payload) {
            state.findedFiles = payload
        }
    },
    getters: {
        findedFiles: state => state.findedFiles,
    },
    actions: {
        getMoodlePrivateFiles(_, {path, userId}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.files.getMoodleFiles.method,
                    params: {
                        wsfunction: apiList.files.getMoodleFiles.moodle_method,
                        contextid: -1,
                        filearea: 'private',
                        component: 'user',
                        itemid: 0,
                        filepath: path,
                        filename: '',
                        instanceid: userId,
                        contextlevel: 'user'
                    }
                }).then(resp => {
                    resolve(resp.data)
                }).catch(err => reject(err))
            })
        },
        searchFiles({commit}, {text, page}) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.files.searchFiles.method,
                    params: {
                        wsfunction: apiList.files.searchFiles.moodle_method,
                    },
                    data: {
                        text: text,
                        page: page
                    }
                }).then(resp => {
                    resolve(resp.data)
                    commit('setFindedFiles', resp.data)

                }).catch(err => reject(err))
            })
        },
        addUserPrivateFiles(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.files.addUserPrivateFiles.method,
                    params: {
                        wsfunction: apiList.files.addUserPrivateFiles.moodle_method,
                    },
                    data: {
                        draftid: payload,
                    }
                })
                    .then(resp => resolve(resp.data))
                    .catch(err => reject(err))
            })
        },
        uploadFile({rootGetters}, payload) {
            return new Promise((resolve, reject) => {
                const form = new FormData();

                form.append("token", getValidToken());
                form.append("moodlewsrestformat", 'json');
                form.append("itemid", payload.id || '0');
                form.append("filepath", payload.path || '/');

                if (payload?.file) {
                    form.append("api_upload", payload.file, payload.file?.name);
                } else if (payload?.files) {
                    for(let i = 0; i < payload.files.length; i++) {
                        form.append(`file_upload${i}`, payload.files[i], payload.files[i]?.name);
                    }
                } else {
                    return
                }

                $axiosUrl({
                    url: `${config.url}webservice/upload.php`,
                    method: 'POST',
                    data: form
                }).then(resp => {
                    if (resp.data.error && resp.data?.errorcode !== 'missingparam') {
                        throw new Error(resp.data.error)
                    } else if (resp.data.error) {
                        throw new Error('Файл превышает максимально допустимый размер.')
                    }

                    const data = resp.data;

                    for(let i = 0; i < data.length; i++) {
                        data[i].id = data[i].itemid
                        data[i].url = `${config.url}/webservice/draftfile.php/${data[i].contextid}/${data[i].component}/${data[i].filearea}/${data[i].itemid}/${data[i].filepath}/${data[i].filename}`;
                    }

                    resolve(data)
                }).catch(err => {
                    console.log(err);
                    reject(err)
                })
            })
        },
        filterFiles({commit}, payload) {
            commit('setFindedFiles', payload)
            return payload
        },
        getCourseResources(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.resource.getResources.method,
                    params: {
                        wsfunction: apiList.resource.getResources.moodle_method,
                        courseids: [payload]
                    }
                }).then(resp => {
                    resolve(resp.data)
                }).catch(err => reject(err))
            })
        },
        triggerResourceView(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.resource.viewResource.method,
                    params: {
                        wsfunction: apiList.resource.viewResource.moodle_method,
                        resourceid: payload
                    }
                })
                    .then(resp => {
                        resolve(resp.data)
                    }).catch(err => reject(err))
            })
        },

        deleteDraftFile(_, payload) {
            return new Promise((resolve, reject) => {
                $axios({
                    method: apiList.files.deleteDraftFile.method,
                    params: {
                        wsfunction: apiList.files.deleteDraftFile.moodle_method,
                    },
                    data: {
                        draftitemid: payload.itemid,
                        files: [
                            {
                                filepath: payload.filepath,
                                filename: payload.filename
                            }
                        ]
                    }
                }).then(resp => {
                    resolve(resp.data)
                }).catch(err => {
                    console.error('Full error:', err.response?.data || err.message)
                    reject(new Error(`Ошибка при удалении файла: ${err.message}`))
                })
            })
        }
    }
}
